<template lang="pug">
  .nav
    slot(name="beforeList")
    .nav__items(:class="itemsClass")
      .nav__item(v-for="item in items")
        .divider(v-if="item.isDivider")
        .nav__link(
          :is="item.link ? 'router-link' : 'div'"
          v-else
          :class="item.link && item.link.name ? {'active': $route.name === item.link.name} : null"

          :to="item.link ? item.link : null"
          @click="item.onClick ? item.onClick() : null"
          :exact="item.exact"
        )
          .nav__link-icon(v-if="item.icon")
            icon(:icon-name="item.icon")
          .nav__link-text(v-html="item.name")
          .nav__link-badge(v-if="item.badge && item.badge.text > 0")
            Badge(
              class="badge_circle"
              :text="item.badge.text"
              type="danger"
              size="sm"
            )
</template>

<script>
import Badge from '@/components/Badge.vue'

export default {
  name: 'Nav',
  components: {
    Badge
  },
  props: {
    items: Array,
    itemsClass: String
  }
}
</script>

<style lang="scss" scoped>
  .nav {
    background: map-get($color-neutral-black, 4);
    border-radius: $border-radius;
    padding: 12px 16px;

    &__item {
      margin-top: 8px;

      &:first-child {
        margin-top: 0;
      }

      .divider {
        margin: 16px 0;
      }
    }

    &__link {
      display: flex;
      align-items: center;
      @include text-md;
      padding: 12px 16px;
      font-weight: $font-weight-semibold;
      text-decoration: none;
      color: map_get($color-neutral-black, 65);
      border-radius: $border-radius;
      transition: $transition-default color;
      cursor: pointer;

      &:hover , &:focus{
        color: inherit;
      }

      &.active {
        background-color: $color-white;
        box-shadow: $elevation-deth-4;
        color: inherit;
      }
    }

    &__link-icon {
      width: 18px;
      height: 18px;
      margin-right: 16px;

      svg {
        display: block;
      }
    }

    &__link-badge {
      line-height: 1;
      margin-left: 8px;
    }
  }
</style>
